/* Honey Bloom motion: scroll pop-ins, floating doodles, walking leopard, pinned steps, fanning kit.
   Turned off by the "Motion" theme setting (body.hbm-still) and by reduced-motion. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function still() { return reduce || document.body.classList.contains('hbm-still'); }
  var $$ = function (sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- pop-ins ---------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.remove('hbm-pre'); e.target.classList.add('hbm-in'); io.unobserve(e.target); } });
  }, { threshold: .15 }) : null;
  function initReveal(root) {
    $$('.hbm-reveal, .hbm-reveal-tilt, .hbm-creator-copy, .hbm-rise, .hbm-free-card', root).forEach(function (el) {
      if (el.dataset.hbmSeen) return; el.dataset.hbmSeen = 1;
      if (!io || still() || window.Shopify && Shopify.designMode) { el.classList.add('hbm-in'); return; }
      if (el.getBoundingClientRect().top > window.innerHeight * 0.95) { el.classList.add('hbm-pre'); io.observe(el); }
      else el.classList.add('hbm-in');
    });
    $$('[data-hbm-hero]', root).forEach(function (h) { h.classList.add('hbm-ready'); });
  }

  /* ---------- parallax doodles ---------- */
  function parallax() {
    var y = window.scrollY;
    $$('[data-hbm-speed]').forEach(function (el) {
      el.style.transform = still() ? 'none' : 'translate3d(0,' + (y * parseFloat(el.dataset.hbmSpeed)) + 'px,0)';
    });
  }

  /* ---------- pinned "how it works" ---------- */
  var stories = [];
  function initStory(root) {
    $$('[data-hbm-story]', root).forEach(function (sec) {
      if (sec.dataset.hbmInit) return; sec.dataset.hbmInit = 1;
      var st = { sec: sec, arts: $$('.hbm-sart', sec), steps: $$('.hbm-step', sec), cur: -1 };
      st.set = function (s) {
        if (s === st.cur) return; st.cur = s;
        st.arts.forEach(function (a) { var on = +a.dataset.s === s; a.classList.toggle('hbm-on', on); if (on) { a.classList.remove('hbm-in'); void a.offsetWidth; a.classList.add('hbm-in'); } });
        st.steps.forEach(function (x) { x.classList.toggle('hbm-on', +x.dataset.s === s); });
      };
      st.set(0); stories.push(st);
      setInterval(function () { var r = sec.getBoundingClientRect(); if (!still() && (window.innerWidth <= 900 || r.height - window.innerHeight <= 0)) st.set((st.cur + 1) % 3); }, 3200);
    });
  }
  function storyScroll() {
    stories.forEach(function (st) {
      var r = st.sec.getBoundingClientRect(), span = r.height - window.innerHeight;
      if (span <= 0 || window.innerWidth <= 900) return;
      st.set(Math.floor(Math.min(.999, Math.max(0, -r.top / span)) * 3));
    });
  }

  /* ---------- branding kit fan ---------- */
  function kitFan() {
    $$('[data-hbm-kit]').forEach(function (kit) {
      if (still()) { kit.style.setProperty('--k', 1); return; }
      var r = kit.getBoundingClientRect(), vh = window.innerHeight;
      var p = Math.min(1, Math.max(0, (vh - r.top) / (vh * 0.75))); p = 1 - Math.pow(1 - p, 3);
      kit.style.setProperty('--k', p.toFixed(3));
    });
  }

  /* ---------- walking leopard + heart paw prints ---------- */
  var walkers = [];
  function initWalker(root) {
    $$('[data-hbm-lane]', root).forEach(function (lane) {
      if (lane.dataset.hbmInit) return; lane.dataset.hbmInit = 1;
      var leo = lane.querySelector('[data-hbm-leo]');
      var w = { lane: lane, leo: leo, prints: [], curX: null, tgtX: 0, ph: 0, amp: 0, raf: 0,
        parts: { l1: leo.querySelector('.hbm-lg1'), l2: leo.querySelector('.hbm-lg2'), l3: leo.querySelector('.hbm-lg3'), l4: leo.querySelector('.hbm-lg4'), tail: leo.querySelector('.hbm-ltail') } };
      var STRIDE = 64, legs = [['l4', 0], ['l1', Math.PI / 2], ['l3', Math.PI], ['l2', Math.PI * 1.5]];
      w.build = function () {
        w.prints.forEach(function (p) { p.remove(); }); w.prints = [];
        var lw = lane.clientWidth, n = Math.ceil((lw + 60) / (STRIDE / 2));
        for (var i = 0; i < n; i++) {
          var p = document.createElement('span'); p.className = 'hbm-paw' + (i % 2 ? ' hbm-far' : '');
          p.innerHTML = '<i class="hbm-pawi"></i>'; p.dataset.x = lw - 20 - i * (STRIDE / 2); p.style.left = p.dataset.x + 'px';
          lane.insertBefore(p, leo); w.prints.push(p);
        }
      };
      w.tick = function (now) {
        w.raf = 0;
        var wd = leo.offsetWidth, lw = lane.clientWidth, d = w.tgtX - w.curX, s = wd / 240;
        if (still()) { w.curX = w.tgtX; d = 0; }
        var dx = d * 0.07; w.curX += dx;
        w.ph += (-dx) / (wd * 0.62) * Math.PI * 2;
        w.amp += (Math.min(1, Math.abs(dx) / (0.9 * s)) - w.amp) * 0.08;
        legs.forEach(function (l) {
          var p = w.ph + l[1], ang = 12 * w.amp * Math.sin(p), lift = 7 * s * w.amp * Math.max(0, Math.cos(p));
          w.parts[l[0]].style.transform = 'translateY(' + (-lift).toFixed(2) + 'px) rotate(' + ang.toFixed(2) + 'deg)';
        });
        w.parts.tail.style.transform = 'rotate(' + (6 * w.amp * Math.sin(w.ph) + 2.5 * Math.sin(now / 700)).toFixed(2) + 'deg)';
        var bob = 2.2 * s * w.amp * (1 - Math.cos(w.ph * 2)) / 2;
        leo.style.transform = 'translate3d(' + w.curX.toFixed(1) + 'px,' + (-bob).toFixed(2) + 'px,0)';
        var foot = w.curX + wd * 0.8;
        w.prints.forEach(function (p) { var px = +p.dataset.x, on = px >= foot; p.style.opacity = on ? Math.max(.18, 1 - (px - foot) / (lw * 0.85)).toFixed(2) : 0; });
        var r = lane.getBoundingClientRect();
        if (!still() && r.bottom > -50 && r.top < window.innerHeight + 50) w.raf = requestAnimationFrame(w.tick);
      };
      w.scroll = function () {
        var lr = lane.getBoundingClientRect(), vh = window.innerHeight, lw = lane.clientWidth, wd = leo.offsetWidth;
        var lp = Math.min(1, Math.max(0, (vh - lr.top) / (vh + lr.height)));
        w.tgtX = (1 - lp) * (lw + 40) - (wd + 40) * lp;
        if (w.curX === null) w.curX = w.tgtX;
        if (!w.raf) w.raf = requestAnimationFrame(w.tick);
      };
      w.build(); walkers.push(w); w.scroll();
    });
  }

  /* ---------- loop ---------- */
  var ticking = false;
  function frame() { ticking = false; parallax(); storyScroll(); kitFan(); walkers.forEach(function (w) { w.scroll(); }); }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
  window.addEventListener('resize', function () { walkers.forEach(function (w) { w.build(); }); frame(); });

  function init(root) { initReveal(root); initStory(root); initWalker(root); frame(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { walkers = walkers.filter(function (w) { return document.body.contains(w.lane); }); stories = stories.filter(function (s) { return document.body.contains(s.sec); }); init(e.target); });
})();

/* ---------- product add-ons: add the theme + ticked matching pieces in one go ---------- */
(function () {
  function money(c) { var f = (window.mabel && window.mabel.moneyFormat) || '${{amount}}'; var a = (c / 100).toFixed(2).replace(/\.00$/, ''); return f.replace(/\{\{\s*amount[^}]*\}\}/, a); }
  document.addEventListener('change', function (e) {
    var box = e.target.closest('[data-hbm-addons]'); if (!box) return;
    var ticked = [].slice.call(box.querySelectorAll('[data-hbm-addon]:checked'));
    var tot = box.querySelector('[data-hbm-total]');
    var sum = +box.dataset.base + ticked.reduce(function (s, i) { return s + (+i.dataset.price); }, 0);
    tot.hidden = !ticked.length; tot.textContent = 'Total with matching pieces: ' + money(sum);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]'); if (!form) return;
    var ticked = [].slice.call(form.querySelectorAll('[data-hbm-addon]:checked')); if (!ticked.length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var root = (window.routes && window.routes.root_url && window.routes.root_url !== '/') ? window.routes.root_url : '';
    var items = [{ id: +form.querySelector('[name="id"]').value, quantity: +(form.querySelector('[name="quantity"]') || { value: 1 }).value || 1 }]
      .concat(ticked.map(function (i) { return { id: +i.dataset.hbmAddon, quantity: 1 }; }));
    var btn = form.querySelector('[type="submit"]'); if (btn) btn.classList.add('is-loading');
    fetch(root + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw 0; return fetch(root + '/?sections=cart-drawer'); })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var drawer = document.getElementById('CartDrawer');
        if (!drawer || !data['cart-drawer']) throw 0;
        var fresh = new DOMParser().parseFromString(data['cart-drawer'], 'text/html').getElementById('CartDrawer');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
        var c = drawer.querySelector('[data-drawer-count]');
        if (c) document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.dataset.drawerCount; el.hidden = c.dataset.drawerCount === '0'; });
        var opener = document.querySelector('[data-open="CartDrawer"]'); if (opener) opener.click(); else location.href = (window.routes && window.routes.cart_url) || '/cart';
      })
      .catch(function () { location.href = (window.routes && window.routes.cart_url) || '/cart'; })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }, true);
})();
